import React, { useEffect } from 'react';

export const Grid = ({ gridColumnCount, grid, gridWidth, gridHeight, gap }) => {

    useEffect(() => {
        console.log('gridColumnCount', gridColumnCount, grid, gridWidth, gridHeight, gap)
    }, [gridColumnCount])

    return (
        <div
            className="grid_dashboard"
        >
            {grid.map((row, rowIndex) =>
                row.map((cell, colIndex) => (
                    <div
                        key={`${rowIndex}-${colIndex}`}
                        className="grid_dashboard_item"
                    >
                    </div>
                ))
            )}
        </div>
    );
};